import { render, staticRenderFns } from "./PopUpSendToDocDigital.vue?vue&type=template&id=3449f007&"
import script from "./PopUpSendToDocDigital.vue?vue&type=script&lang=js&"
export * from "./PopUpSendToDocDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3449f007')) {
      api.createRecord('3449f007', component.options)
    } else {
      api.reload('3449f007', component.options)
    }
    module.hot.accept("./PopUpSendToDocDigital.vue?vue&type=template&id=3449f007&", function () {
      api.rerender('3449f007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpSendToDocDigital.vue"
export default component.exports